// Converte textos como "R$ 2.500,00", "1.234,5" ou "42" em número. Retorna null se não for numérico.
export function parseNumericValue(text: string): number | null {
  const trimmed = text.trim();
  if (!trimmed) return null;

  const cleaned = trimmed.replace(/^r\$\s*/i, '').replace(/\s+/g, '').replace(/%$/, '');
  if (!/^-?\d{1,3}(\.\d{3})*(,\d+)?$|^-?\d+([.,]\d+)?$/.test(cleaned)) return null;

  let normalized = cleaned;
  if (normalized.includes(',') && normalized.includes('.')) {
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  } else if (normalized.includes(',')) {
    normalized = normalized.replace(',', '.');
  }

  const value = parseFloat(normalized);
  return Number.isNaN(value) ? null : value;
}

export function isColumnNumeric(texts: string[]): boolean {
  const nonEmpty = texts.filter((t) => t.length > 0);
  if (nonEmpty.length === 0) return false;

  const numericCount = nonEmpty.filter((t) => parseNumericValue(t) !== null).length;
  return numericCount / nonEmpty.length >= 0.5;
}

export function compareTexts(aText: string, bText: string, numeric: boolean, direction: 'asc' | 'desc'): number {
  if (numeric) {
    const aNum = parseNumericValue(aText);
    const bNum = parseNumericValue(bText);

    if (aNum === null && bNum === null) return 0;
    if (aNum === null) return 1; // não numérico sempre no fim, em qualquer direção
    if (bNum === null) return -1;

    return direction === 'asc' ? aNum - bNum : bNum - aNum;
  }

  const cmp = aText.localeCompare(bText, 'pt-BR', { sensitivity: 'base' });
  return direction === 'asc' ? cmp : -cmp;
}
